<template>
  <div class="flex flex-col items-center gap-4">
    <Transition
      enter-active-class="animate-in fade-in zoom-in-95 duration-200"
      leave-active-class="animate-out fade-out zoom-out-95 duration-200"
      mode="out-in"
    >
      <SupportList v-if="isSupportListView" @close="isSupportListView = false" />
      <div v-else class="flex flex-col items-center gap-4 w-full">
        <img
          :src="getImageUrl('home/empty/empty-bot.webp')"
          alt="empty"
          class="w-full mt-4 object-contain max-h-75"
        />
                <div
          class="flex items-center justify-between p-4 w-full text-m-medium bg-glass30 rounded-full"
        >
          <span class="text-text-glass-default">{{ $t('home.emptyState.webSupporting') }}</span>
          <span
            class="text-brand-blue1 cursor-pointer transition-colors hover:text-text-hover"
            @click="isSupportListView = true"
          >
            {{ $t('home.emptyState.webSupportListBtn') }}
          </span>
        </div>
        <div class="flex items-center gap-4 w-full">
          <p class="text-wrap text-text-glass-default max-w-90">
            {{ $t('home.emptyState.webSupportEmpty') }}
          </p>
          <div class="flex items-center gap-4">
            <div
              v-for="broswer in supportBrowsers"
              :key="broswer.name"
              class="flex items-center gap-1"
            >
              <Icon :icon="broswer.icon" class="size-6" />
              <span class="text-text-glass-default">{{ broswer.name }}</span>
            </div>
          </div>
        </div>
        <div class="flex items-center gap-4 w-full">
          <p class="text-wrap text-text-glass-default line-through">
            {{ $t('home.emptyState.webUnsupportEmpty') }}
          </p>
          <div class="flex items-center gap-4 line-through">
            <div
              v-for="broswer in unsupportBrowsers"
              :key="broswer.name"
              class="flex items-center gap-1"
            >
              <Icon :icon="broswer.icon" class="size-6" />
              <span class="text-text-glass-default">{{ broswer.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </Transition>

    <div class="flex items-center gap-1">
      <Button color="black" size="lg" class="w-73" :loading="isScanning" @click="$emit('scan')">
        <Icon icon="Tab-Wireframe-Key" />
        {{ $t('home.emptyState.connectButton') }}
      </Button>
      <Tooltip align="start" :align-offset="-10">
        <template #content>
          <div class="p-1 w-90 bg-floating-tooltip-container rounded-lg text-white-black">
            <p>{{ $t('home.emptyState.permissionTip1') }}</p>
            <p>{{ $t('home.emptyState.permissionTip2') }}</p>
          </div>
        </template>
        <Icon
          icon="Function-Wireframe-Description"
          class="size-6 text-black-white outline-none ring-0"
        />
      </Tooltip>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'
  import { Button, Icon, Tooltip } from '@rapoo/element'
  import { getImageUrl } from '@/utils/assets'
  import SupportList from './SupportList.vue'

  const supportBrowsers = [
    {
      icon: 'APP-Fill-Google',
      name: 'Google Chrome',
    },
    {
      icon: 'APP-Fill-Edge',
      name: 'Edge',
    },
    {
      icon: 'APP-Fill-Opera',
      name: 'Opera',
    },
  ]

  const unsupportBrowsers = [
    {
      icon: 'APP-Fill-IE',
      name: 'IE',
    },
    {
      icon: 'APP-Fill-Safari',
      name: 'Safari',
    },
    {
      icon: 'APP-Fill-Firefox',
      name: 'Mozilla Firefox',
    },
  ]

  defineProps<{
    isScanning: boolean
  }>()

  defineEmits<{
    (e: 'scan'): void
  }>()

  const isSupportListView = ref(false)
</script>
